import { apiClient } from '@/utils/api';

export interface Appointment {
  id: string;
  title: string;
  description?: string;
  clientId: string;
  client: {
    id: string;
    firstName: string;
    lastName: string;
    phone?: string;
    email?: string;
  };
  practiceId?: string;
  practice?: {
    id: string;
    title: string;
    type?: {
      name: string;
      code: string;
      color?: string;
    };
  };
  userId?: string;
  user?: {
    id: string;
    firstName: string;
    lastName: string;
    email?: string;
  };
  startTime: string;
  endTime: string;
  status: string;
  location?: string;
  reminderSent: boolean;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AppointmentQueryParams {
  clientId?: string;
  practiceId?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export const appointmentService = {
  async getAppointments(params: AppointmentQueryParams = {}) {
    const response = await apiClient.get(`appointments`, { params });
    return response.data;
  },

  async getAppointment(id: string) {
    const response = await apiClient.get(`appointments/${id}`);
    return response.data;
  },

  async createAppointment(data: Partial<Appointment>) {
    const response = await apiClient.post(`appointments`, data);
    return response.data;
  },

  async updateAppointment(id: string, data: Partial<Appointment>) {
    const response = await apiClient.put(`appointments/${id}`, data);
    return response.data;
  },

  async deleteAppointment(id: string) {
    const response = await apiClient.delete(`appointments/${id}`);
    return response.data;
  },

  async updateAppointmentStatus(id: string, status: string) {
    const response = await apiClient.put(`appointments/${id}/status`, { status });
    return response.data;
  },

  async getAppointmentsByMonth(year: number, month: number, userId?: string) {
    const response = await apiClient.get(`appointments/month/${year}/${month}`, {
      params: userId ? { userId } : {},
    });
    return response.data;
  },

  async getAppointmentsByWeek(year: number, week: number, userId?: string) {
    const response = await apiClient.get(`appointments/week/${year}/${week}`, {
      params: userId ? { userId } : {},
    });
    return response.data;
  },

  async getUpcomingAppointments(days: number = 30, userId?: string) {
    const response = await apiClient.get(`appointments/upcoming`, {
      params: { days, userId },
    });
    return response.data;
  },
};

